import type { IModelMemory } from 'shared/types'
import { client } from '../clients'

const getList = () => client.get<IModelMemory[]>('/memories/model-memories')

export const modelMemories = {
  getList
}
